<!--直播课-->
<template>
    <div class="el-LiveClass">
        <h1 class="head_title">直播课</h1>

          <iframe :src="this.url" width="100%" height="700px"></iframe>
         
    </div>
  </template>
  <script>
  export default {
    name: "liveCourse",
    data() {
      return {
        url:this.$route.params.url,
      };
    },
    created() {
      //this.wrongQuestionQuery();
      //alert(this.url);
    },
    methods: {
        
    }
  };
  </script>
  <style  lang="less">
    @import '../../styles/base.less';
    .el-WrongQuestion{
      .head_title_white{
          text-align: right;
          margin-bottom:0;
          padding: 10px 30px;
      }
      .bg_{
          height: 10px;
          background-color: @mainBg;
          margin: 0 -20px;
      }
      .learning_img{
          width: 280px;height: 220px;border: 1px solid rgb(238, 238, 238);float: left;margin-right: 20px;
      }
      .el-main{
          min-width: 1200px;
      }
      .block {
        text-align: center;
        width: 96%;
        margin-bottom: 20px;
        margin-top: 20px;
      }
      .zyleft{
          float: left;
          line-height: 150px;
          padding: 0 40px 0 25px;
          font-size: 20px;
          color: @primary;
      }
      .zy{
          border: 1px solid rgb(164, 164, 255);width: 650px;height: 150px;border-radius: 10px;margin: 25px auto;padding: 0 20px;
      }
      .odyContainer{
          height: 100%;
      }
    }
  </style>
  


// WEBPACK FOOTER //
// src/pages/live/LiveCourse.vue